import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Headroom from "react-headroom";
import classNames from "classnames/bind";
import styles from "./index.css";
import { showFilterOverlay } from "../../../../../state/modules/layout/actions";
import { hasSelectedFacets } from "../../../../../state/modules/search/selectors";
import FilterLayoutContainer from "../../../../FilterLayout";
import { withTranslation } from "../../../../../components/translation";
import { SmallViewportOnly } from "../../../../ViewportOnly";
import SmallScreenSort from "../../../../../components/Sort/SmallScreenSort";
import RefinementListContainer from "../../../../../components/RefinementsList";
import RefinementListCloseButton from "../../../../../components/RefinementsList/CloseButton";
import {
  CATEGORY_BANNER_ID,
  SEARCH_TERM_ID,
  CHROME_BREADCRUMB_ID
} from "../../../../../components/constants";

const combineClasses = classNames.bind(styles);

const pinStartElements = (CLIENT
  ? [
      document.getElementById(CHROME_BREADCRUMB_ID),
      document.getElementById(CATEGORY_BANNER_ID),
      document.getElementById(SEARCH_TERM_ID)
    ]
  : []
).filter(elem => !!elem);

const getPinStart = () =>
  pinStartElements.reduce(
    (offset, elem) => offset + Math.max(elem.offsetHeight, elem.clientHeight),
    0
  );

export const SmallScreenHeader = ({
  formatTranslation,
  showFilterOverlay,
  hasSelectedFacets
}) => (
  <SmallViewportOnly>
    <Headroom
      className={styles.stickyHeader}
      disableInlineStyles={true}
      pinStart={getPinStart}
      upTolerance={17}
    >
      <div className={styles.sortControls}>
        <SmallScreenSort />
      </div>
      <div className={styles.filterControls}>
        <button
          className={combineClasses({
            filterButton: true,
            filterButton_checked: hasSelectedFacets
          })}
          onClick={showFilterOverlay}
        >
          {formatTranslation("plp_web_search_filter_label")}
        </button>
      </div>
    </Headroom>
    <FilterLayoutContainer>
      <RefinementListCloseButton />
      <RefinementListContainer />
    </FilterLayoutContainer>
  </SmallViewportOnly>
);

SmallScreenHeader.propTypes = {
  showFilterOverlay: PropTypes.func.isRequired,
  formatTranslation: PropTypes.func.isRequired,
  hasSelectedFacets: PropTypes.bool.isRequired
};

SmallScreenHeader.displayName = "SmallScreenHeader";

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    hasSelectedFacets: hasSelectedFacets(state)
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      showFilterOverlay
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation(SmallScreenHeader));
